import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DeleteAccountModal = () => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();

  return (
    <Flex
      flexDirection="column"
      gap={40}
      pb={40}
      pt={isTabletSM ? 80 : 30}
      px={40}
    >
      <Flex flexDirection="column" gap={8}>
        <Typography
          color={theme.colors.white[100]}
          variant="MS-regular-s26-lh32"
        >
          {i18n.t('ProfilePage.DeleteProfile.Modal.title')}
        </Typography>
        <Typography
          color={theme.colors.alto[100]}
          variant="MS-regular-s16-lh25"
        >
          {i18n.t('ProfilePage.DeleteProfile.Modal.subtitle')}
        </Typography>
      </Flex>
    </Flex>
  );
};

export default DeleteAccountModal;
